var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDiscount(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "vuesax/linear/receipt-disscount"
  }, /*#__PURE__*/React.createElement("g", {
    id: "receipt-disscount"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M4.20625 12.3125C4.71875 11.7625 5.5 11.8063 5.95 12.4063L6.58125 13.25C7.0875 13.9188 7.90625 13.9188 8.4125 13.25L9.04375 12.4063C9.49375 11.8063 10.275 11.7625 10.7875 12.3125C11.9 13.5 12.8062 13.1062 12.8062 11.4437V4.4C12.8125 1.88125 12.225 1.25 9.8625 1.25H5.1375C2.775 1.25 2.1875 1.88125 2.1875 4.4V11.4375C2.1875 13.1062 3.1 13.4938 4.20625 12.3125Z",
    stroke: "#30322C",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M5.625 8.125L9.375 4.375",
    stroke: "#30322C",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M9.37157 8.125H9.37718",
    stroke: "#30322C",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M5.62157 4.6875H5.62718",
    stroke: "#30322C",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDiscount);
export default __webpack_public_path__ + "static/media/discount.ccb0a8882a341c0d7390f861cd9b2b5b.svg";
export { ForwardRef as ReactComponent };